import { Box, Typography } from "@mui/material"
import type { ReactElement } from "react"

interface ProductOriginGridValuesProps {
  productOrigin: {
    country: string
    region: string
    city: string
    address?: string | null
  }
  testIdPrefix: string
}

export const ProductOriginGridValues = ({
  productOrigin,
  testIdPrefix,
}: ProductOriginGridValuesProps): ReactElement => {
  return productOrigin.address ? (
    <Box className='col-span-3 flex items-center border-l px-2 py-4' data-testid={`${testIdPrefix}-address`}>
      <Typography variant='body2'>{productOrigin.address || "-"}</Typography>
    </Box>
  ) : (
    <>
      <Box
        className='flex items-center border-b px-2 py-4'
        data-testid={`${testIdPrefix}-country`}
        sx={{ borderRight: "none" }}
      >
        <Typography variant='body2'>{productOrigin.country || "-"}</Typography>
      </Box>
      <Box
        className='flex items-center border-b px-2 py-4'
        data-testid={`${testIdPrefix}-region`}
        sx={{ borderLeft: "none", borderRight: "none" }}
      >
        <Typography variant='body2'>{productOrigin.region || "-"}</Typography>
      </Box>
      <Box
        className='flex items-center border-b px-2 py-4'
        data-testid={`${testIdPrefix}-city`}
        sx={{ borderLeft: "none", borderRight: "none" }}
      >
        <Typography variant='body2'>{productOrigin.city || "-"}</Typography>
      </Box>
    </>
  )
}
